export default __webpack_public_path__ + "static/media/chat2.50cc9f57.jpg";